"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionModal = void 0;
var react_1 = __importStar(require("react"));
var storm_ui_1 = require("@amzn/storm-ui");
var action_modal_styles_1 = require("./action_modal.styles");
var loading_button_1 = require("../LoadingButton/loading_button");
var ActionModal = function (props) {
    var header = props.header, toggleButtonLabel = props.toggleButtonLabel, actionLabel = props.actionLabel, alert = props.alert, confirmationText = props.confirmationText, toggleButtonTestId = props.toggleButtonTestId, onAction = props.onAction, disabled = props.disabled, children = props.children, loading = props.loading, error = props.error;
    var _a = (0, react_1.useState)(false), isModalOpen = _a[0], setIsModalOpen = _a[1];
    var _b = (0, react_1.useState)(false), isChecked = _b[0], setCheckBox = _b[1];
    var toggleCheck = function () {
        setCheckBox(function (prev) { return !prev; });
    };
    var getDisabled = function () {
        if (confirmationText) {
            return !isChecked;
        }
        else {
            return false;
        }
    };
    var ActionModalFooter = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(action_modal_styles_1.FooterContainer, null,
            react_1.default.createElement(action_modal_styles_1.SpacedButton, { onClick: function () { return setIsModalOpen(false); } }, "Cancel"),
            react_1.default.createElement(loading_button_1.LoadingButton, { onClickSend: function () {
                    onAction()
                        .then(function () { return setIsModalOpen(false); })
                        .catch(function () {
                        // Ignore the error, user will take action
                    });
                }, isLoading: !!loading, isDisabled: disabled || getDisabled(), sendLabel: actionLabel, loadingLabel: actionLabel, withMargin: true }),
            error && react_1.default.createElement(action_modal_styles_1.ErrorText, null, error.message))));
    var modalProps = {
        isOpen: isModalOpen,
        header: header,
        footer: ActionModalFooter,
        onClose: function () { return setIsModalOpen(false); },
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storm_ui_1.Modal, __assign({}, modalProps),
            react_1.default.createElement(action_modal_styles_1.ModalContentContainer, null,
                alert && (react_1.default.createElement(action_modal_styles_1.StyledAlert, { type: alert.level, header: alert.heading }, alert.text)),
                react_1.default.createElement("div", null,
                    children,
                    confirmationText && react_1.default.createElement(action_modal_styles_1.SpacedCheckbox, { checked: isChecked, onChange: toggleCheck, id: "confirmation-checkbox", label: confirmationText })))),
        react_1.default.createElement(storm_ui_1.TextButton, { size: 'small', "data-testid": toggleButtonTestId, onClick: function () { return setIsModalOpen(true); } }, toggleButtonLabel)));
};
exports.ActionModal = ActionModal;
